import { render } from "./DocumentosListar.vue?vue&type=template&id=0db12321&scoped=true"
import script from "./DocumentosListar.vue?vue&type=script&lang=js"
export * from "./DocumentosListar.vue?vue&type=script&lang=js"

import "./DocumentosListar.vue?vue&type=style&index=0&id=0db12321&lang=scss&scoped=true"
import "./DocumentosListar.vue?vue&type=style&index=1&id=0db12321&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db12321"]])

export default __exports__